import { Classroom } from "./components/Classroom";
import "./App.css";

export default function App() {
  return (
    <div className="app">
      <Classroom />
    </div>
  );
}
